// Import the functions you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // ✅ أضيفي هذا
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDjbhUSvnxbI2RgTSbEydJVg1eTphqL7ZA",
  authDomain: "kids-shop-26485.firebaseapp.com",
  projectId: "kids-shop-26485",
  storageBucket: "kids-shop-26485.firebasestorage.app",
  messagingSenderId: "278445387681",
  appId: "1:278445387681:web:39e8aa9b4f8419430e25e0",
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Firestore
export const db = getFirestore(app);


// Storage
export const storage = getStorage(app); // ✅ أضيفي هذا
export const auth = getAuth(app);
